import './bootstrap';

// Import everything from autoload
import './autoload/_lazysizes'
import './autoload/_smartresize'
import './autoload/_slick-carousel'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

import pageBlockHero from './routes/blocks/hero';
import pageBlockEventFilter from './routes/blocks/event-filter';
import pageBlockResourcesCards from './routes/blocks/resources-cards';
import pageBlockTestimonials from './routes/blocks/testimonials';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,

	// Blocks
	pageBlockHero,
	pageBlockEventFilter,
	pageBlockResourcesCards,
	pageBlockTestimonials
});

// Load Events
$(document).ready(() => routes.loadEvents());
